import React, { useReducer, useEffect, useState } from "react"
import { useSelector } from "react-redux"

import store from "redux/store"
import { login } from "redux/ducks/user"
import { withRouter } from "react-router"
import { window_open } from "utils/util"
import { setChartSession } from "components/atoms/chart/logic/chartSession"
import { get, pick, mapValues } from "lodash"
import ClassNames from "classnames"
import { UserStorage } from "utils/userStorage"

type ActionType = {
  type: "CHANGE_BRANCH" | "CHANGE_ID" | "CHANGE_PASS"
  value: string
}
type LoginInfoType = {
  branch: string | null
  id: string | null
  pass: string | null
  message: string | null
}
const initialInfo: LoginInfoType = {
  branch: null,
  id: null,
  pass: null,
  message: null,
}

const setLoginInfo = (state: LoginInfoType, action: ActionType) => {
  switch (action.type) {
    case "CHANGE_BRANCH":
      return { ...state, branch: action.value }
    case "CHANGE_ID":
      return { ...state, id: action.value }
    case "CHANGE_PASS":
      return { ...state, pass: action.value }
  }
}

const checkInput = (loginInfo: LoginInfoType) => {
  if (!loginInfo.branch || !loginInfo.id || !loginInfo.pass) {
    loginInfo.message = "未入力項目があります"
    return false
  } else {
    loginInfo.message = null
    return true
  }
}

export const Login = withRouter(({ history }) => {
  const _loginInfo = UserStorage.loginInfo.get()
  const [passSaveFlag, setPassSaveFlag] = useState(
    !!get(_loginInfo, "save_flag")
  )
  const _initialInfo = (() => {
    if (!passSaveFlag) return initialInfo
    const data = { ...initialInfo }
    return { ...data, ...pick(_loginInfo, ["branch", "id", "pass"]) }
  })()
  const [loginInfo, setLogin] = useReducer(setLoginInfo, {
    branch: "300",
    id: "3000016",
    pass: "0000",
    message: "",
  })
  const loginSelector = (state: any) => state.user.UserInfo
  const [errorMessage, setErrorMessage] = useState("")
  const userInfo = useSelector(loginSelector)
  const [btnState, setBtnState] = useState(false)
  const [passVisible, setPassVisible] = useState(false)
  const executeLogin = async () => {
    if (!checkInput(loginInfo) || btnState) return
    setBtnState(true)
    const sessionTimeout = get(
      UserStorage.sessionTimeout.get(),
      "sessionTimeout"
    )
    if (sessionTimeout) {
      window.open("", "Main-Page").close()
    }
    await store.dispatch(
      login(loginInfo.branch, loginInfo.id, loginInfo.pass, () => {
        window_open("./#/sso", {}, "Main-Page")
        UserStorage.sessionTimeout.set({ sessionTimeout: false })
        // 情報を保存する処理。passSaveFlagがfalseなら処理せず抜ける。
        if (!passSaveFlag) return
        UserStorage.loginInfo.set({
          ...pick(loginInfo, ["branch", "id", "pass"]),
          save_flag: passSaveFlag,
        })
      })
    )
    setBtnState(false)
    setChartSession()
  }
  const onkeypress = (e: any) => {
    if (e.key === "Enter") {
      executeLogin()
    }
  }

  useEffect(() => {
    if (!get(userInfo, "Result")) return setErrorMessage("")
    setErrorMessage(
      "部店番号またはログインIDまたはログインパスワードが違います。入力内容をご確認ください。"
    )
  }, [userInfo])

  // // ログイン情報保存フラグが変更時の処理。
  // useEffect(() => {
  //   // passSaveFlagがfalseの場合、nullに書き換える。
  //   const _data = mapValues(
  //     pick(_loginInfo, ["branch", "id", "pass"]),
  //     items => {
  //       if (!passSaveFlag) return null
  //       return items
  //     }
  //   )
  //   UserStorage.loginInfo.set({
  //     ..._data,
  //     save_flag: passSaveFlag,
  //   })
  //   if (!passSaveFlag) {
  //     setLogin({ type: "CHANGE_BRANCH", value: "" })
  //     setLogin({ type: "CHANGE_ID", value: "" })
  //     setLogin({ type: "CHANGE_PASS", value: "" })
  //   }
  // }, [passSaveFlag])

  return (
    <div className="login demo">
      <div className="panel">
        <div className="login-icon-wrapper">
          <div className="demo-logo">DEMO</div>
          <div className="brand-lockup" />
        </div>
        <div className="login-input-group">
          <div className="filter-control-item floating-input-field">
            <input
              className="search-input"
              type="text"
              name=""
              placeholder="部店"
              disabled={true}
              value={"123"}
              onChange={e =>
                setLogin({ type: "CHANGE_BRANCH", value: e.target.value })
              }
            />
          </div>
          <div className="filter-control-item floating-input-field">
            <input
              className="search-input"
              type="text"
              name=""
              placeholder="ログインID"
              disabled={true}
              value={"1234567"}
              onChange={e =>
                setLogin({ type: "CHANGE_ID", value: e.target.value })
              }
            />
          </div>
          <div className="filter-control-item floating-input-field">
            <input
              id="pass"
              className="search-input"
              type="password"
              name=""
              placeholder="パスワード"
              disabled={true}
              value={"1234"}
              onChange={e =>
                setLogin({ type: "CHANGE_PASS", value: e.target.value })
              }
              onKeyPress={e => onkeypress(e)}
            />
            <div
              onClick={() => {
                // passwordのマスキングの有無を変更。
                const elem = document.getElementById("pass")
                if (passVisible) elem.setAttribute("type", "password")
                if (!passVisible) elem.setAttribute("type", "text")
                setPassVisible(!passVisible)
              }}
            >
              <i className="material-icons">
                {!passVisible ? "visibility" : "visibility_off"}
              </i>
            </div>
          </div>
          {/*<div className="filter-control-item">*/}
          {/*  <label className="checkbox-control">*/}
          {/*    <input*/}
          {/*      type="checkbox"*/}
          {/*      checked={passSaveFlag}*/}
          {/*      onChange={() => {*/}
          {/*        setPassSaveFlag(!passSaveFlag)*/}
          {/*      }}*/}
          {/*    />*/}
          {/*    <span>ログイン情報を保存する</span>*/}
          {/*  </label>*/}
          {/*</div>*/}
          {errorMessage && (
            <div className="login-error-message">
              <span>{errorMessage}</span>
            </div>
          )}
        </div>
        <div className="login-execute-wrapper">
          <div
            className={ClassNames("btn btn-primary", { disabled: btnState })}
            onClick={() => executeLogin()}
          >
            ログイン
          </div>
        </div>
      </div>
    </div>
  )
})
